import { Layer, Source } from 'react-map-gl'
import { FillLayer } from 'mapbox-gl';
import { useEffect, useContext, useState } from 'react';
import { RefContext } from '../../RefContext'
import { parse, unparse } from 'papaparse';
import { Expression, StyleFunction } from 'mapbox-gl';
import * as d3Array from 'd3-array';
import * as d3Format from 'd3-format';
import * as d3Scale from 'd3-scale';
import * as d3ScaleChromatic from 'd3-scale-chromatic';
import localForage from "localforage";
import type { LayerProps } from 'react-map-gl';

const EDDIDrought = (props: any) => {
    const {
        id,
        beforeId = "",
        fillColor,
        opacity,
        outlineColor,
        tileSet,
        sourceLayer,
        global
    } = props

    const locationField = 'huc8'; //HUC12
    const storagePrefix = 'huc8q';
    const data2022 = "/eddi/eddi_2022_huc8.csv";
    const datapre2022 = "/eddi/eddi_thru1980_1999thru2000_2021_huc8.csv";
    const ls_eddi = "layer_eddi_processedq";
    const ls_eddi2022 = "data2022q";
    const ls_eddipre2022 = "datapre2022q";

    const initLayerStyle: LayerProps = {
      id: `${id}`,
      "source-layer": `${sourceLayer}`,
      type: 'fill' as const,
      beforeId: 'aerialway',
      layout: { 'visibility': (false) ? 'visible' : 'none' },
      paint: {
        'fill-color': fillColor,
        "fill-opacity": opacity,
        
      }
    };

    const [layerStyle, setLayerStyle] = useState<any>(initLayerStyle);

    const { currentRef } = useContext(RefContext)
    // @ts-ignore
    const mapInstance = currentRef && currentRef?.current

    const yearEx = [2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995, 1994, 1993, 1992, 1991, 1990, 1989, 1988, 1987, 1986, 1985, 1984, 1983, 1982, 1981];
    const monthEx = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

    const thru2000_2021 = ["2000_01","2000_02","2000_03","2000_04","2000_05","2000_06","2000_07","2000_08","2000_09","2000_10","2000_11","2000_12","2001_01","2001_02","2001_03","2001_04","2001_05","2001_06","2001_07","2001_08","2001_09","2001_10","2001_11","2001_12","2002_01","2002_02","2002_03","2002_04","2002_05","2002_06","2002_07","2002_08","2002_09","2002_10","2002_11","2002_12","2003_01","2003_02","2003_03","2003_04","2003_05","2003_06","2003_07","2003_08","2003_09","2003_10","2003_11","2003_12","2004_01","2004_02","2004_03","2004_04","2004_05","2004_06","2004_07","2004_08","2004_09","2004_10","2004_11","2004_12","2005_01","2005_02","2005_03","2005_04","2005_05","2005_06","2005_07","2005_08","2005_09","2005_10","2005_11","2005_12","2006_01","2006_02","2006_03","2006_04","2006_05","2006_06","2006_07","2006_08","2006_09","2006_10","2006_11","2006_12","2007_01","2007_02","2007_03","2007_04","2007_05","2007_06","2007_07","2007_08","2007_09","2007_10","2007_11","2007_12","2008_01","2008_02","2008_03","2008_04","2008_05","2008_06","2008_07","2008_08","2008_09","2008_10","2008_11","2008_12","2009_01","2009_02","2009_03","2009_04","2009_05","2009_06","2009_07","2009_08","2009_09","2009_10","2009_11","2009_12","2010_01","2010_02","2010_03","2010_04","2010_05","2010_06","2010_07","2010_08","2010_09","2010_10","2010_11","2010_12","2011_01","2011_02","2011_03","2011_04","2011_05","2011_06","2011_07","2011_08","2011_09","2011_10","2011_11","2011_12","2012_01","2012_02","2012_03","2012_04","2012_05","2012_06","2012_07","2012_08","2012_09","2012_10","2012_11","2012_12","2013_01","2013_02","2013_03","2013_04","2013_05","2013_06","2013_07","2013_08","2013_09","2013_10","2013_11","2013_12","2014_01","2014_02","2014_03","2014_04","2014_05","2014_06","2014_07","2014_08","2014_09","2014_10","2014_11","2014_12","2015_01","2015_02","2015_03","2015_04","2015_05","2015_06","2015_07","2015_08","2015_09","2015_10","2015_11","2015_12","2016_01","2016_02","2016_03","2016_04","2016_05","2016_06","2016_07","2016_08","2016_09","2016_10","2016_11","2016_12","2017_01","2017_02","2017_03","2017_04","2017_05","2017_06","2017_07","2017_08","2017_09","2017_10","2017_11","2017_12","2018_01","2018_02","2018_03","2018_04","2018_05","2018_06","2018_07","2018_08","2018_09","2018_10","2018_11","2018_12","2019_01","2019_02","2019_03","2019_04","2019_05","2019_06","2019_07","2019_08","2019_09","2019_10","2019_11","2019_12","2020_01","2020_02","2020_03","2020_04","2020_05","2020_06","2020_07","2020_08","2020_09","2020_10","2020_11","2020_12","2021_01","2021_02","2021_03","2021_04","2021_05","2021_06","2021_07","2021_08","2021_09","2021_10","2021_11","2021_12"]
    const thru1980_1999 = ["1980_01","1980_02","1980_03","1980_04","1980_05","1980_06","1980_07","1980_08","1980_09","1980_10","1980_11","1980_12","1981_01","1981_02","1981_03","1981_04","1981_05","1981_06","1981_07","1981_08","1981_09","1981_10","1981_11","1981_12","1982_01","1982_02","1982_03","1982_04","1982_05","1982_06","1982_07","1982_08","1982_09","1982_10","1982_11","1982_12","1983_01","1983_02","1983_03","1983_04","1983_05","1983_06","1983_07","1983_08","1983_09","1983_10","1983_11","1983_12","1984_01","1984_02","1984_03","1984_04","1984_05","1984_06","1984_07","1984_08","1984_09","1984_10","1984_11","1984_12","1985_01","1985_02","1985_03","1985_04","1985_05","1985_06","1985_07","1985_08","1985_09","1985_10","1985_11","1985_12","1986_01","1986_02","1986_03","1986_04","1986_05","1986_06","1986_07","1986_08","1986_09","1986_10","1986_11","1986_12","1987_01","1987_02","1987_03","1987_04","1987_05","1987_06","1987_07","1987_08","1987_09","1987_10","1987_11","1987_12","1988_01","1988_02","1988_03","1988_04","1988_05","1988_06","1988_07","1988_08","1988_09","1988_10","1988_11","1988_12","1989_01","1989_02","1989_03","1989_04","1989_05","1989_06","1989_07","1989_08","1989_09","1989_10","1989_11","1989_12","1990_01","1990_02","1990_03","1990_04","1990_05","1990_06","1990_07","1990_08","1990_09","1990_10","1990_11","1990_12","1991_01","1991_02","1991_03","1991_04","1991_05","1991_06","1991_07","1991_08","1991_09","1991_10","1991_11","1991_12","1992_01","1992_02","1992_03","1992_04","1992_05","1992_06","1992_07","1992_08","1992_09","1992_10","1992_11","1992_12","1993_01","1993_02","1993_03","1993_04","1993_05","1993_06","1993_07","1993_08","1993_09","1993_10","1993_11","1993_12","1994_01","1994_02","1994_03","1994_04","1994_05","1994_06","1994_07","1994_08","1994_09","1994_10","1994_11","1994_12","1995_01","1995_02","1995_03","1995_04","1995_05","1995_06","1995_07","1995_08","1995_09","1995_10","1995_11","1995_12","1996_01","1996_02","1996_03","1996_04","1996_05","1996_06","1996_07","1996_08","1996_09","1996_10","1996_11","1996_12","1997_01","1997_02","1997_03","1997_04","1997_05","1997_06","1997_07","1997_08","1997_09","1997_10","1997_11","1997_12","1998_01","1998_02","1998_03","1998_04","1998_05","1998_06","1998_07","1998_08","1998_09","1998_10","1998_11","1998_12","1999_01","1999_02","1999_03","1999_04","1999_05","1999_06","1999_07","1999_08","1999_09","1999_10","1999_11","1999_12"]

    const yearExtentData = () => {
      let newFill = [] as any;
      for (let dataItem of yearEx) {
        for (let dataI of monthEx) { 
            newFill.push(dataItem + '_' + dataI);
        }
      }
      newFill.sort();
      return newFill;
    }

    useEffect(() => {
        //updateSlider
        let yeD = yearExtentData();
        global.setYearMonthRange(yeD);
    }, [])


    const colorScalePoints = (evalValue: number) => {
       let eddiScale =  d3Scale.scaleLinear()
          .domain([0, .15, .35, .45, .55, .6, .7, .8, .9, 1])//@ts-ignore
          .range(['darkblue', 'blue', 'lightblue', 'white', 'white', 'yellow', '#e6c3a3', 'orange', 'red', 'darkred'])      
        const colorValue =  d3ScaleChromatic.interpolateBrBG(1-evalValue); //interpolateRdYlBu(//eddiScale(evalValue) d3ScaleChromatic.interpolateTurbo(evalValue)//interpolateRdYlGn
        return colorValue;
    } 


    const stepParse = (fileURL: any, filteredArray: any) => {
       let matchObj = {};
       let matchExpressionZip = ['match', ['get', locationField]] as Expression;
       let matchExpressionFilter = ['in', locationField] as Expression;

        for (let dataItem of filteredArray) { 
            //@ts-ignore 
            matchObj[dataItem] = [...matchExpressionZip];
        }


      const pointsExtent = [-1.62, 1.99]; //[-1.62, 1.99]

      const legendNormalizedScale = d3Scale.scaleLinear()
        .domain([0, 1])
        .range([pointsExtent[0], pointsExtent[1]]);

      const legendScale = d3Scale.scaleLinear()
        .domain([pointsExtent[0], pointsExtent[1]])
        .range([0, 1]);

        let nArray = [] as any;
        let cfips = [] as any;

        //@ts-ignore
        const data: any[] = parse(fileURL, {
            download: true,
            header: true,
            skipEmptyLines: true,
            step: function(results) {
                if(results && results.data){
                    //@ts-ignore
                   if(results.data.huc12 && cfips.indexOf(results.data.huc12.substr(0,8)) < 0){
                       //@ts-ignore
                        cfips.push(results.data.huc12.substr(0,8))
                    
                        for (let dataItem of filteredArray) {                   
                            //if(dataItem === '2022_12'){
                                //@ts-ignore
                                const colorValue = colorScalePoints(legendScale(results.data[dataItem])); 
                                if(colorValue){//@ts-ignore
                                    //matchExpressionZip.push(results.data.huc12.substr(0,8));
                                    //matchExpressionZip.push(colorValue);
                                    matchObj[dataItem].push(results.data.huc12.substr(0,8));//@ts-ignore
                                    matchObj[dataItem].push(colorValue);
                                   // mapExpExport.push({huc12: dataItem[groupKey], color: colorValue})
                                }   
                        }
                    }
                }
            },
            complete: function(results) {
                console.log('Complete(((((((((((((', fileURL, results, nArray, matchExpressionZip, matchObj)
                

                if(fileURL === datapre2022){
                    localStorage.setItem(ls_eddipre2022, "0")
                }
                
                let layerEDDIprocessed = localStorage.getItem(ls_eddi);
                if(layerEDDIprocessed){
                    let newProcess = JSON.parse(layerEDDIprocessed).concat(filteredArray);
                    localStorage.setItem(ls_eddi, JSON.stringify(newProcess))
                } else {
                    localStorage.setItem(ls_eddi, JSON.stringify(filteredArray))
                }

                for (let dataItem of filteredArray) {
                            //@ts-ignore
                          matchObj[dataItem].push('rgba(0,0,0,0)');
                        //@ts-ignore
                    localForage.setItem(storagePrefix + dataItem, matchObj[dataItem])
                    //console.log('huc8_' + dataItem)
                    if(global.selectedYearMonth === dataItem){
                        console.log('MATCH');
                        //@ts-ignore
                        let matchExpressionFilter = ['in', locationField] as Expression;
                        //@ts-ignore
                        updateLayerS(matchExpressionFilter, matchObj[dataItem]);
                    }
                }

            }
        });

    }


    const loadInitialData = (fileURL:any) => {
        //console.log('loadInitialData', fileURL);
        //const fileURL = data2022;//
        //let layerEDDIprocessed = localStorage.getItem(ls_eddi);


        //@ts-ignore
       const data: any[] = parse(fileURL, {
            download: true,
            header: true,
            preview: 2,
            complete: function(results) {
               //console.log('parse', results);
               //batchUpdate(results.data)
               if(results.data && results.data[0]){
                 const keys = Object.keys(results.data[0])
                     .map((key) => key)
                    .sort();
                 const filteredArray = keys.filter(item => item !== 'huc12');
                stepParse(fileURL, filteredArray);            
               }
            }
        });
    }

    useEffect(() => {
        console.log('global.selectedYearMonth', global.selectedYearMonth)
        if (global.selectedYearMonth) {      
            let matchExpressionFilter = ['in', locationField] as Expression;
            //loadInitialData();
            localForage.getItem(global.selectedYearMonth, function(err, value) {
                if(value){
                    console.log('localForage.getItem', storagePrefix + global.selectedYearMonth)
                    updateLayerS(matchExpressionFilter, value);
                } else {
                    if(localStorage.getItem(ls_eddi2022)!=="1"){
                        loadInitialData(data2022);
                        localStorage.setItem(ls_eddi2022, "1")
                    }  
/*                    let newStops = createMapStops(huc12, 'huc12', global.selectedYearMonth);
                    setTimeout(() => {
                        updateLayerS(matchExpressionFilter, newStops);
                        localForage.setItem(global.selectedYearMonth, newStops);
                    },111);*/
                } 
            });
        } 
    }, [])

    function round(value: any, decimals_:any) {
        let decimals = 2;
        //@ts-ignore
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }


    let fullArray = [] as any;

    const processRawData = () => {
        console.log('processRawData');
        const filteredArray = thru1980_1999.concat(thru2000_2021);
        const fileArray = ['001', '002', '003', '004', '005', '006', '007', '008']
        let nArray = [] as any;
        for (let dataIt of fileArray) {

            let fileURL = "/EDDI_historical" + dataIt + ".csv";
            console.log(fileURL);
            let cfips = [] as any;

            //@ts-ignore
            const data: any[] = parse(fileURL, {
                download: true,
                header: true,
                skipEmptyLines: true,
                step: function(results) {
                    if(results && results.data){
                        //@ts-ignore
                        if(results.data.huc12 && results.data.huc12.substr(0,8)  === '17010207'){
                            //console.log(results)  
                        }

                        //@ts-ignore
                       if(results.data.huc12 && cfips.indexOf(results.data.huc12.substr(0,8)) < 0){
                           //@ts-ignore
                            cfips.push(results.data.huc12.substr(0,8))
                        
                            //@ts-ignore
                            let newObj = {huc12 : results.data.huc12, huc8 : results.data.huc12.substr(0,8)}
                            for (let dataItem of filteredArray) {  

                                //newObj[dataItem] = 0;
                                //@ts-ignore  
                                newObj[dataItem] = round(results.data[dataItem], 2);
                                //@ts-ignore    
                                 //results.data[dataItem] = round(results.data[dataItem], 2); 

                            }
                            nArray.push(newObj)
                        }

                    }
                },
                complete: function() {
                    fullArray = fullArray.concat(nArray)
                    console.log('complete', dataIt, nArray.length, fullArray.length)

                    if(fullArray.length> 20000){
                        const csv = unparse(fullArray);
                        let hiddenElement = document.createElement('a');
                        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                        hiddenElement.target = '_blank';
                        hiddenElement.download = 'eddi_thru1980_1999thru2000_2021' + '.csv';
                        hiddenElement.click();
                        if (hiddenElement.parentNode) {
                          hiddenElement.parentNode.removeChild(hiddenElement);
                        }
                        hiddenElement.remove();
                    }
                }
            });
        }
    }


/*
      useEffect(() => {
        if (mapInstance) {
          mapInstance.on('click', (event: any) => {
              console.log(id, mapInstance.getStyle())
            const layerObject = mapInstance.queryRenderedFeatures(event.point, {
               layers: [id],
             });
            console.log(layerObject)
            //setFeatures(layerObject)
          })
        }
      }, [mapInstance])*/


    useEffect(() => {
        console.log('global.selectedYearMonth', global.selectedYearMonth, storagePrefix, ls_eddi2022, localStorage.getItem(ls_eddi2022), ls_eddipre2022, localStorage.getItem(ls_eddipre2022) )

        if (global.selectedYearMonth ) {                  
            let matchExpressionFilter = ['in', locationField] as Expression;
            localForage.getItem(storagePrefix + global.selectedYearMonth, function(err, value) {
                if(value){
                    //console.log('localForage.getItem', storagePrefix + global.selectedYearMonth, value)
                    updateLayerS(matchExpressionFilter, value);
                } else {
                    //console.log('substr(0,4)', global.selectedYearMonth.substr(0,4))
                    if(global.selectedYearMonth && global.selectedYearMonth.substr(0,4)==='2022'){
                         
                        if(localStorage.getItem(ls_eddi2022)!=="1"){
                            loadInitialData(data2022);
                            localStorage.setItem("data2022", "1")
                        }  

                    } else {
                        if(localStorage.getItem(ls_eddipre2022)!=="1"){
                            loadInitialData(datapre2022);
                            localStorage.setItem(ls_eddipre2022, "1")
                        }
                    }                    
                }
            });
        }
    }, [global.selectedYearMonth])



  const createMapStops = (rData: any, groupKey: string, selectedCategory: string) => {
    let matchExpressionZip = ['match', ['get', locationField]] as Expression;
    let matchExpressionFilter = ['in', locationField] as Expression;

    //let mapExpExport = [] as any;

    const yearExtent = d3Array.extent<any, any>(rData, d => +d[selectedCategory]);

    let cfips = [] as any;
    if (rData.length > 0) {
      let gKey = locationField;
      const pointsExtent = yearExtent; //[-1.62, 1.99]

      const legendNormalizedScale = d3Scale.scaleLinear()
        .domain([0, 1])
        .range([pointsExtent[0], pointsExtent[1]]);

      const legendScale = d3Scale.scaleLinear()
        .domain([pointsExtent[0], pointsExtent[1]])
        .range([0, 1]);

          for (let dataItem of rData) {
            //matchExpressionFilter.push(+dataItem.fips);
            if (cfips.indexOf(dataItem[groupKey].substr(0,8)) < 0) {
              const colorValue = colorScalePoints(legendScale(dataItem[selectedCategory]));
              if (!isNaN(+dataItem[groupKey])) {
                  if(colorValue){
                        matchExpressionZip.push(dataItem[groupKey].substr(0,8));
                        matchExpressionZip.push(colorValue);
                       // mapExpExport.push({huc12: dataItem[groupKey], color: colorValue})
                  } else {
                     //console.log(dataItem[groupKey], dataItem[selectedCategory])
                  }

              } else {
                  console.log('isNaN')
              }
            } 
            cfips.push(dataItem[groupKey].substr(0,8));
          }
      //
      matchExpressionZip.push('rgba(0,0,0,0)');

      //setMapExpression(matchExpressionZip);

      return matchExpressionZip;
    }
  }

  //"fill-outline-color": `${outlineColor}`,

  const updateLayerS = (mapFilterExp: any, mapExp: any) => {
      //console.log('updateLayerS')
    const newLayerStyle: LayerProps = {
      id: `${id}`,
      "source-layer": `${sourceLayer}`,
      type: 'fill' as const,
      beforeId: 'aerialway',
      layout: { 'visibility': (true) ? 'visible' : 'none' },
      paint: {
        'fill-color': mapExp,
        "fill-opacity": opacity,
        
      }
    };
    setLayerStyle(newLayerStyle);
  }    


    return (
        <>
            <Source
                id={`${id}`}
                type="vector"
                url={tileSet}
            >
                <Layer
                    beforeId={beforeId}
                    {...layerStyle} 
                />
            </Source>
        </>
    )
}

export default EDDIDrought;  